module.exports = __webpack_public_path__ + "static/250503_Investor_Presentation_final_v2-cd74cdc4d66d19182a9730bc851b5e4a.pdf";